module.exports = __webpack_public_path__ + "img/New Zealand.c740a8d4.png";